import {inject} from "@angular/core";
import {Router, ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable, of, EMPTY} from "rxjs";
import {mergeMap, take} from "rxjs/operators";
import {LiveResultsService} from "@services";
import {LANDING_ROUTE} from "../app-routing.module";
import {
    CompetitorFilter, CompetitorResults,
    DEFAULT_PAGE_INDEX,
    PAGE_SIZE_10,
    PagedFilter,
    Pages
} from "@model";

export const LiveResultsResolver: ResolveFn<Observable<CompetitorResults[] | null> |
  Promise<CompetitorResults[]> | CompetitorResults[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   liveResultsService: LiveResultsService = inject(LiveResultsService),
   router: Router = inject(Router)): Observable<CompetitorResults[] | null> |
    Promise<CompetitorResults[]> | CompetitorResults[] => {
    let currentPath: string | undefined = route.routeConfig?.path;
    let raceId: number | undefined = +route.queryParams['raceId'] ? +route.queryParams['raceId'] : undefined;
    let resultsFilter: CompetitorFilter = new CompetitorFilter();
    resultsFilter.raceId = raceId;
    if (!currentPath?.includes("fullscreen")) {
      resultsFilter.name = route.queryParams['name'] ? route.queryParams['name'] : undefined;
      resultsFilter.gender = route.queryParams['gender'] ? route.queryParams['gender'] : undefined;
    }
    if (raceId) {
      return liveResultsService.getCompetitorLiveResults(
        new PagedFilter<CompetitorFilter>(new Pages(PAGE_SIZE_10, DEFAULT_PAGE_INDEX), resultsFilter))
        .pipe(
          take(1),
          mergeMap((res: CompetitorResults[] | null | undefined) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([LANDING_ROUTE]);
              return EMPTY;
            }
          })
        );
    } else {
      router.navigate([LANDING_ROUTE]);
      return EMPTY;
    }

  }
